var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-wrp",style:(_vm.customStyle)},[_c('p',{staticClass:"tag-tit",style:({
      color: _vm.getTextColor(),
      background: _vm.getBgColor(),
      padding: _vm.haveBgColor || _vm.haveRgbaBgColor ? '2px 12px' : 'none'
    })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }